import wdk from '@larsgw/wikibase-sdk/commonjs/wikidata.org';
import config from './config.json';
function parseWikidata(data, langs) {
  const ids = Array.isArray(data) ? data : [data];
  for (const id of ids) {
    if (!/^Q[1-9][0-9]*$/.test(id)) {
      throw new Error(`Entity "${id}" not found`);
    }
  }
  const urls = wdk.getManyEntities({
    ids,
    languages: langs || config.langs
  });
  return Array.isArray(urls) ? urls : [urls];
}
export { parseWikidata as parse, parseWikidata as default };